/**
 * Converts HTTP image URLs to HTTPS for iOS App Transport Security compliance
 * This must happen BEFORE the image is rendered to prevent iOS from blocking the request
 */
export function secureImageUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }
  
  // Already HTTPS or data URI - no conversion needed
  if (url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  
  // Convert HTTP to HTTPS
  if (url.startsWith('http://')) {
    const httpsUrl = url.replace('http://', 'https://');
    console.log('🔒 secureImageUrl: HTTP → HTTPS', httpsUrl.substring(0, 80));
    return httpsUrl;
  }
  
  // Return unchanged if not a recognized protocol
  return url;
}
